<template>
    <div>
        <b-card v-if="isLoaded">
            <div style="position: sticky; top:70px; z-index: 2;">
                <b-row align-h="between">
                    <template>
                        <b-col md="2">
                            <b-row>
                                <span>{{ $t('data-type') }}</span>
                            </b-row>
                            <b-row>
                                <b-form-select 
                                    v-model="selectedDataType"
                                    style="width: 100%"><!-- class="gray-select" -->
                                    <option 
                                        v-for="dataType in getDataTypes()" 
                                        v-bind:ref="'dataType'" 
                                        :value="dataType.id" 
                                        :key="dataType.id">
                                    {{ dataType.name + dataType.unit }}
                                    </option>
                                </b-form-select>
                            </b-row>
                        </b-col>
                        <b-col md="2">
                            <b-row>
                                <span>{{ $t('reporting-period') }}</span>
                            </b-row>
                            <b-row>
                                <el-date-picker
                                    v-model="reportDateRange"
                                    type="monthrange"
                                    format="MMM yyyy"
                                    align="right"
                                    unlink-panels
                                    range-separator="-"
                                    :picker-options="pickerOptions"
                                    style="width: 100%;">
                                </el-date-picker>
                            </b-row>
                        </b-col>
                        <b-col md="2">
                            <b-row>
                                <span>{{ $t('comparing-period') }}</span>
                            </b-row>
                            <b-row>
                                <b-form-select 
                                    v-model="compareDateRange"
                                    style="width: 100%"><!-- class="gray-select" -->
                                    <option 
                                        v-for="dateRange in comparableDateRanges" 
                                        v-bind:ref="'dateRange'" 
                                        :value="dateRange.id" 
                                        :key="dateRange.id">
                                        {{ dateRange.name }}
                                    </option>
                                </b-form-select>
                            </b-row>
                        </b-col>
                        <b-col md="1">
                            <b-row>
                                <span>{{ $t('normalization-parameter') }}</span>
                            </b-row>
                            <b-row>
                                <b-form-select 
                                    v-model="normalizationType"
                                    style="width: 100%">
                                    <option 
                                        v-for="normalization in normalizationTypes" 
                                        v-bind:ref="'normalization'" 
                                        :value="normalization.id" 
                                        :key="normalization.id">
                                        {{ normalization.name }}
                                    </option>
                                </b-form-select>
                            </b-row>
                        </b-col>
                        <b-col md="1">
                            <b-row>
                                <span>{{ $t('site-type') }}</span>
                            </b-row>
                            <b-row>
                                <b-form-select
                                    v-if="allSiteTypes.length" 
                                    v-model="selectedTypeId"
                                    style="width: 100%">
                                    <option 
                                        v-for="siteType in allSiteTypes" 
                                        v-bind:ref="'siteType'" 
                                        :value="siteType.id" 
                                        :key="siteType.id">
                                        {{ $t(siteType.name) }}
                                    </option>
                                </b-form-select>
                            </b-row>
                        </b-col>
                        <b-col md="1">
                            <b-row>
                                <span>{{ $t('regionTitle') }}</span>
                            </b-row>
                            <b-row>
                                <b-form-select
                                    v-model="selectedRegionId"
                                    style="width: 100%">
                                    <option 
                                        v-for="region in regions" 
                                        v-bind:ref="'region'" 
                                        :value="region.id" 
                                        :key="region.id">
                                        {{ region.display_name }}
                                    </option>
                                </b-form-select>
                            </b-row>
                        </b-col>
                        <b-col md="1">
                            <b-row>
                                <span>{{ $t('Site') }}</span>
                            </b-row>
                            <b-row>
                                <b-form-select
                                    v-model="selectedSiteId"
                                    style="width: 100%">
                                    <option v-if="filteredSites.length>0" :value="null">{{ $t('all') }}</option>
                                    <option v-else :value="null">-</option>
                                    <option 
                                        v-for="site in filteredSites" 
                                        v-bind:ref="'site'" 
                                        :value="site.id" 
                                        :key="site.id">
                                        {{ site.name }}
                                    </option>
                                </b-form-select>
                            </b-row>
                        </b-col>
                        <b-col md="1">
                            <b-row>
                                <span v-if="isFiltering">{{ $t('filtering') }}</span>
                                <span v-else>{{ $t('filter') }}</span>
                            </b-row>
                            <b-row>
                                <template v-if="isFiltering">
                                    <b-button v-b-tooltip.hover :title="$t('filtering')" :disabled="true" :key="1"><i class="fas fa-circle-notch fa-spin"></i></b-button>
                                </template>
                                <template v-else>
                                    <b-button v-b-tooltip.hover :title="$t('filter')" @click="getFilteredData()" :disabled="!isFilterable()" :key="2"><i class="fas fa-filter"></i></b-button>
                                </template>
                            </b-row>
                        </b-col>

                    </template>
                </b-row>
                        
                <b-row style="margin-top: 50px;">
                    <div style="width:100%;height:30%;" v-show="items.length>0">
                        <bar-chart :chart-data="barChartData" :options="barChartOptions" :chart-id="barChartId"/>
                    </div>
                </b-row>

                <b-row style="margin-top: 50px;text-align:right;float:right;">
                    <div v-show="items.length>0">
                        <b-button v-b-tooltip.hover :title="$t('download')" @click="downloadExcel()" :disabled="isDownloading" style="background-color:rgba(76, 175, 80, 0);color:#000;"><i class="fas fa-file-excel"></i></b-button>
                    </div>
                </b-row>
                <b-row style="margin-top: 100px;">
                    <div v-show="items.length>0" class="table-responsive">
                    <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em">
                        <thead>
                            <tr>
                            <th style="width: 10em;text-align: center;" :class="sortedClass('location')" @click="sortBy('location')">{{ $t('Location') }}</th>
                            <th style="width: 10em;text-align: center;" :class="sortedClass('site-type')" @click="sortBy('site-type')">{{ $t('site-type') }}</th>
                            <th style="width: 10em;text-align: center;" :class="sortedClass('region')" @click="sortBy('region')">{{ $t('regionTitle') }}</th>
                            <th style="width: 10em;text-align: center;" :class="sortedClass('area')" @click="sortBy('area')">{{ $t('areaTitle') }}</th>
                            <th style="width: 10em;text-align: center;" :class="sortedClass('numberOfStaff')" @click="sortBy('numberOfStaff')">{{ $t('numberOfStaff') }}</th>
                            <th style="width: 10em;text-align: center;" :class="sortedClass('dt1')" @click="sortBy('dt1')">{{ dataType1Title }}<br>{{ dataType1TitlePart2 }}</th>
                            <th style="width: 10em;text-align: center;" :class="sortedClass('dt2')" @click="sortBy('dt2')">{{ dataType2Title }}<br>{{ dataType2TitlePart2 }}</th>
                            <th style="width: 10em;text-align: center;" :class="sortedClass('diffrence')" @click="sortBy('diffrence')">{{ $t('diffrence') }}</th>
                            <th style="width: 10em;text-align: center;" :class="sortedClass('diffrenceRatio')" @click="sortBy('diffrenceRatio')">{{ $t('diffrence') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items" :key="index">
                                <td>{{ item.name }}</td>
                                <td>{{ $t(item.type) }}</td>
                                <td> {{ item.region }}</td>
                                <td>
                                    {{ (item.reportingData.properties.area) }}
                                </td>
                                <td>
                                    {{ (item.reportingData.properties.staff) }}
                                </td>
                                <td :title="(item.reportingData.total.consumption ? (item.reportingData.total.consumption + ' ' + item.normalizedUnit) : 0)">
                                    {{ item.reportingData.total.consumption ? (item.reportingData.total.consumption.toFixed(2) + ' ' + item.normalizedUnit) : "-" }}
                                </td>
                                <td :title="(item.comparingData.total.consumption ? (item.comparingData.total.consumption + ' ' + item.normalizedUnit) : 0)" >
                                    {{ item.comparingData.total.consumption ? (item.comparingData.total.consumption.toFixed(2) + ' ' + item.normalizedUnit) : "-" }}
                                </td>
                                <td :title="item.change.consumptionChange" :style="item.style">
                                    {{ (item.change.consumptionChange && item.reportingData.total.consumption && item.comparingData.total.consumption) ? item.change.consumptionChange.toFixed(2) + ' ' + item.normalizedUnit : "-" }}
                                </td>
                                <td :title="item.change.consumptionRationChange + '%'" :style="item.style">
                                    {{ (item.change.consumptionRationChange && item.reportingData.total.consumption && item.comparingData.total.consumption) ? (item.change.consumptionRationChange.toFixed(0) + "%") : "-" }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                </b-row>        

            </div>
            
        </b-card>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import SiteTypeSelect from '../../../components/SiteTypeSelect.vue';
import RegionMultiSelect from '../../../components/RegionMultiSelect.vue';
import BarChart from '../../../components/charts/BarChart.vue';
import uuidV4 from 'uuid/v4';
//import moment from 'moment';

export default {
    components: {SiteTypeSelect, RegionMultiSelect, BarChart},
    name: 'Compare',
    data() {
        return {
            isLoaded: false,
            reportDateRange:[],
            compareDateRange:null,
            selectedDataType:null,
            comparableDateRanges:[],
            normalizationType: 0,
            selectedTypeId: null,
            selectedRegionId: null,
            selectedSiteId: null,
            allSiteTypes: [],
            regions: [],
            filteredSites: [],
            isFiltering: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: 'This month',
                        onClick(picker) {
                        const date = new Date();
                        const start = new Date(date.getFullYear(), date.getMonth(), 1);
                        picker.$emit('pick', [start, start]);
                        }
                    }, {
                        text: 'This year',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date(new Date().getFullYear(), 0);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Last 6 months',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() - 6);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
            },
            normalizationTypes:[
                {id:0, name:this.$t("-")},
                {id:1, name:this.$t("areaTitle")},
                {id:2, name:this.$t("person")},
            ],
            dataType1Title:"",
            dataType1TitlePart2:"",
            dataType2Title:"",
            dataType2TitlePart2:"",
            rawItems:[],
            lastFilter:null,
            items:[],
            barChartId: uuidV4(),
            isDownloading:false,
            barChartUnit: "",
            barChartData: {
                labels: [],
                datasets: []
            },
            colourPalette: [
                'rgba(168,188,208,1)',
                'rgba(66,73,89,1)'
            ],
            barChartOptions: {
                legend: {
                    position: 'bottom'
                },
                title: {
                    display: false,
                    fontColor: '#555',//text: this.$t('comparingScope'),
                    fontSize: 16,
                    padding: 15
                },
                barValueSpacing: 20,
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                min: 0
                            }
                        }
                    ]
                },
                tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						label: function(tooltipItems) {
							return tooltipItems.yLabel.toFixed(2);
						}
					}
				},
                responsive: true,
				maintainAspectRatio: false
            },
            tableLastSort:null,
            tableSortDir:'asc'
        };
    },

    filters: {
        toRatio(dividend, divider) {
            divider = _.toNumber(divider);
            dividend = _.toNumber(dividend);
            return divider && dividend !== Infinity
                ? (100 * ((dividend - divider) / divider)).toFixed(0)
                : '-';
        }
    },

    methods: {
        sortedClass(key){
            return this.tableLastSort === key ? `sorted ${this.tableSortDir=='asc' ? 'asc' : 'desc' }` : '';
        },
        sortBy(key=null){
            if(key != null){
                if(key != this.tableLastSort){
                    this.tableLastSort=key;
                    this.tableSortDir='desc';
                }
                else{
                    this.tableSortDir = this.tableSortDir=='asc'?'desc':'asc';
                }
            }
            else{
                key = this.tableLastSort
            }
            
            switch(key){
                case 'location':
                    this.items = _.orderBy(this.items, ['name'], [this.tableSortDir=='asc'?'desc':'asc']);
                    break;
                case 'site-type':
                    this.items = _.orderBy(this.items, ['type'], [this.tableSortDir=='asc'?'desc':'asc']);
                    break;
                case 'region':
                    this.items = _.orderBy(this.items, ['region'], [this.tableSortDir=='asc'?'desc':'asc']);
                    break;
                case 'area':
                    this.items = _.orderBy(this.items, o=>(o.reportingData.properties.area), [this.tableSortDir]);
                    break;
                case 'numberOfStaff':
                    this.items = _.orderBy(this.items, o=>(o.reportingData.properties.staff), [this.tableSortDir]);
                    break;
                case 'dt1':
                    this.items = _.orderBy(this.items, o=>(o.reportingData.total.consumption), [this.tableSortDir]);
                    break;
                case 'dt2':
                    this.items = _.orderBy(this.items, o=>(o.comparingData.total.consumption), [this.tableSortDir]);
                    break;
                case 'diffrence':
                    this.items = _.orderBy(this.items, o=>((o.change.consumptionChange && o.reportingData.total.consumption && o.comparingData.total.consumption) ? (o.change.consumptionChange) : 0), [this.tableSortDir]);
                    break;
                case 'diffrenceRatio':
                    this.items = _.orderBy(this.items, o=>((o.change.consumptionRationChange && o.reportingData.total.consumption && o.comparingData.total.consumption) ? (o.change.consumptionRationChange) : 0), [this.tableSortDir]);
                    break;
                default:
                    break;
            }
        },
        getDataTypes(){
            let filteredOptions = [];
            let units = [];
            _.each(this.$store.state.dataTypes, dataType => {
                let unit = [];
                filteredOptions.push(dataType);
                unit.name =
                    ' (' +
                    this.$t(_.find(this.$store.state.units, {id: dataType.unit_id_1}).name) +
                    ')';
                unit.id = dataType.id;
                units.push(unit);
            });
            filteredOptions.forEach(dataType => {
                dataType.name = this.$t(dataType.name);
                dataType.unit = _.find(units, {id: dataType.id}).name;
            });
            return filteredOptions;
        },
        downloadExcel(){
            if(!this.isDownloading){
                this.isDownloading=true;

                let excelData = {
                    locale:this.$store.state.locale,
                    headers:[
                        this.$t('Location'),
                        this.$t('site-type'),
                        this.$t('regionTitle'),
                        this.$t('areaTitle'),
                        this.$t('numberOfStaff'),
                        this.dataType1Title+" "+this.dataType1TitlePart2,
                        this.dataType2Title+" "+this.dataType2TitlePart2,
                        this.$t('diffrence'),
                        this.$t('diffrence')
                    ],
                    data:[[],[],[],[],[],[],[],[],[]]
                };

                _.each(this.items, item=>{
                    excelData.data[0].push(item.name);
                    excelData.data[1].push(this.$t(item.type));
                    excelData.data[2].push(item.region);
                    excelData.data[3].push((item.reportingData.properties.area));
                    excelData.data[4].push((item.reportingData.properties.staff));
                    excelData.data[5].push((item.reportingData.total.consumption ? (item.reportingData.total.consumption.toFixed(2) + ' ' + item.normalizedUnit) : "-"));
                    excelData.data[6].push((item.comparingData.total.consumption ? (item.comparingData.total.consumption.toFixed(2) + ' ' + item.normalizedUnit) : "-"));
                    excelData.data[7].push(((item.change.consumptionChange && item.reportingData.total.consumption && item.comparingData.total.consumption) ? (item.change.consumptionChange.toFixed(2) + ' ' + item.normalizedUnit) : "-"));
                    excelData.data[8].push(((item.change.consumptionRationChange && item.reportingData.total.consumption && item.comparingData.total.consumption) ? (item.change.consumptionRationChange.toFixed(0) + "%") : "-"));
                });

                this.$Progress.start();
                return this.axios.post('/exportExcel', excelData, {responseType: 'blob', headers: { 'Accept': 'application/vnd.ms-excel' }})
                .then(data => {
                    this.downloadExcelBlob(data,"comparison.xlsx");
                    /*
                    var blob = new Blob([data.data], {type: 'application/vnd.ms-excel'});
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', "test.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    */
                    this.isDownloading = false;
                    return this.$Progress.finish();
                });
            }
        },
        isFilterable(){
            return !(this.selectedDataType == null || this.reportDateRange == null || this.reportDateRange == [] || this.compareDateRange == null || this.filteredSites.length <= 0 || this.isFiltering);
        },
        getFilteredData(){
            if(this.isFilterable()){
                let filterOptions = {
                    dataTypeId:this.selectedDataType,
                    reportingPeriod:{
                        startDate:moment(this.reportDateRange[0]).format("YYYY-MM-DD"),
                        endDate:moment(this.reportDateRange[1]).add(1, 'M').format("YYYY-MM-DD"),
                    },
                    comparingPeriod:{
                        startDate:moment(this.reportDateRange[0]).add(this.compareDateRange, 'y').format("YYYY-MM-DD"),
                        endDate:moment(this.reportDateRange[1]).add(this.compareDateRange, 'y').add(1, 'M').format("YYYY-MM-DD"),
                    },
                    normalizationType:this.normalizationType,
                    siteTypeId:this.selectedTypeId,
                    regionId:this.selectedRegionId,
                    siteId:this.selectedSiteId,
                    locale:this.$store.state.locale
                };

                this.isFiltering = true;
                return this.axios.post('/getComparisonData', filterOptions)
                            .then(({data}) => {
                                this.rawItems=data;
                                this.lastFilter=filterOptions;
                                this.prepareData(data,filterOptions);
                                this.isFiltering = false;
                            })
            }
        },
        rePrepareData(){
            this.prepareData(this.rawItems,this.lastFilter);
        },
        prepareData(data,filterOptions){
            let normalizationType = _.head(_.filter(this.normalizationTypes, nt=> nt.id==filterOptions.normalizationType));
            let dataType = _.head(_.filter(this.$store.state.dataTypes, dt=>dt.id==filterOptions.dataTypeId));
            let dataUnit = this.$t(dataType.unit.replace(/[()]+/g, ''));

            this.dataType1Title = this.$t(dataType.name);
            this.dataType1TitlePart2 = "("+moment(filterOptions.reportingPeriod.startDate).lang(this.$store.state.locale).format("MMM YYYY")+" - "+moment(filterOptions.reportingPeriod.endDate).add(-1, 'M').lang(this.$store.state.locale).format("MMM YYYY")+")";
            this.dataType2Title = this.$t(dataType.name);
            this.dataType2TitlePart2 = "("+moment(filterOptions.comparingPeriod.startDate).lang(this.$store.state.locale).format("MMM YYYY")+" - "+moment(filterOptions.comparingPeriod.endDate).add(-1, 'M').lang(this.$store.state.locale).format("MMM YYYY")+")";

            this.barChartData = {
                labels: [],
                datasets: []
            };

            let barChardKeysForComparation = Object.keys(_.head(data).comparingData.data);
            let barChardKeysForReporting = Object.keys(_.head(data).reportingData.data);
            this.barChartData.labels = _.map(_.head(data).comparingData.data, o=>o.month);
 
            
            let comparationDataArray = Array(barChardKeysForComparation.length).fill(0);
            let reportingDataArray = Array(barChardKeysForComparation.length).fill(0);

            _.each(data, d=>{
                let comparingTotal = {consumption:0,cost:0};
                let reportTotal = {consumption:0,cost:0};

                if(normalizationType.id == 1){
                    d.normalizedUnit = dataUnit +'/m2';
                    d.comparingData.normalizationValue=d.comparingData.properties.area;
                    d.reportingData.normalizationValue=d.reportingData.properties.area;
                }
                else if(normalizationType.id == 2){
                    d.normalizedUnit = dataUnit+'/'+this.$t('person');
                    d.comparingData.normalizationValue=d.comparingData.properties.staff;
                    d.reportingData.normalizationValue=d.reportingData.properties.staff;
                }
                else{
                    d.normalizedUnit = dataUnit;
                    d.comparingData.normalizationValue=1;
                    d.reportingData.normalizationValue=1;
                }


                _.each(d.comparingData.data, cData=>{
                    cData.normalizedConsumption = (cData.consumption && d.comparingData.normalizationValue) ? cData.consumption/d.comparingData.normalizationValue : 0;
                    cData.normalizedCost = (cData.cost && d.comparingData.normalizationValue) ? cData.cost/d.comparingData.normalizationValue : 0;

                    comparingTotal.consumption += cData.normalizedConsumption ? cData.normalizedConsumption : 0;
                    comparingTotal.cost += cData.normalizedCost ? cData.normalizedCost : 0;
                });
                d.comparingData.total = comparingTotal;
                _.each(d.reportingData.data, rData=>{
                    rData.normalizedConsumption = (rData.consumption && d.reportingData.normalizationValue) ? rData.consumption/d.reportingData.normalizationValue : 0;
                    rData.normalizedCost = (rData.cost && d.reportingData.normalizationValue) ? rData.cost/d.reportingData.normalizationValue : 0;

                    reportTotal.consumption += rData.normalizedConsumption ? rData.normalizedConsumption : 0;
                    reportTotal.cost += rData.normalizedCost ? rData.normalizedCost : 0;
                });

                d.reportingData.total = reportTotal;

                d.change = {
                    consumptionChange: reportTotal.consumption-comparingTotal.consumption,
                    consumptionRationChange: (reportTotal.consumption-comparingTotal.consumption)/comparingTotal.consumption*100,
                    costChange: reportTotal.cost-comparingTotal.cost,
                    costRationChange: (reportTotal.cost-comparingTotal.cost)/comparingTotal.cost*100,
                };
                d.style= "";

                if(d.change.consumptionRationChange<-30 || d.change.consumptionRationChange>30){
                    d.style="color:#DC143C;";
                }else{
                    d.style="color:#000;";
                }

                _.each(barChardKeysForComparation, (key,index)=>{
                    comparationDataArray[index] += _.get(d.comparingData.data, key).normalizedConsumption;
                    reportingDataArray[index] += _.get(d.reportingData.data, barChardKeysForReporting[index]).normalizedConsumption;
                });
            });

            /*
            this.barChartUnit = _.head(data).normalizedUnit;
            this.barChartOptions.tooltips.callbacks.label = function(tooltipItems) {
                                                                return tooltipItems.yLabel.toFixed(2)+" "+this.barChartUnit;
                                                            }
            */


            this.barChartData.datasets.push({
                label: this.$t('reporting-period'),
                backgroundColor: this.colourPalette[1],
                data:reportingDataArray
                });
            this.barChartData.datasets.push({
                label: this.$t('comparing-period'),
                backgroundColor: this.colourPalette[0],
                data:comparationDataArray
                });

            this.items=data;
            this.sortBy();
        },
        retriveData(){
            //this.barChartData.height = 500;
            this.allSiteTypes = [{id: null, name: this.$t('all')}, ...this.siteTypes];
            this.regions = [{id: null, display_name: this.$t('allRegions')}, ...this.siteGroups];
            this.setFilteredSiteList();

            this.pickerOptions.shortcuts[0].text=this.$t("this-month");
            this.pickerOptions.shortcuts[1].text=this.$t("this-year");
            this.pickerOptions.shortcuts[2].text=this.$t("last-6-months");
            this.isLoaded = true;
        },
        setFilteredSiteList(){
            this.selectedSiteId = null;
            this.filteredSites = _.filter(this.sites, site=>{
                if(this.selectedTypeId == null && this.selectedRegionId == null){
                    return true;
                }
                else if(this.selectedRegionId == null){
                    return site.typeId == this.selectedTypeId;
                }
                else if(this.selectedTypeId == null){
                    return site.siteGroupId == this.selectedRegionId;
                }
                else{
                    return (site.siteGroupId == this.selectedRegionId && site.typeId == this.selectedTypeId);
                }
            });
        }
    },
    watch:{
        selectedTypeId(){
            this.selectedSiteId = null;
            this.setFilteredSiteList();
        },
        selectedRegionId(){
            this.selectedSiteId = null;
            this.setFilteredSiteList();
        },
        reportDateRange(val){
            if(val[0] && val[1]){
                this.comparableDateRanges = [];
                for (let i = -5; i < 0; i++) {
                    if (i==0) {continue;}
                    this.comparableDateRanges.push({
                    'id':i,
                    'name': Math.abs(i) + " " + (i > 0 ? this.$t('next-year'): this.$t('previous-year')) + " (" + moment(val[0]).add(i, 'y').lang(this.$store.state.locale).format('MMM YYYY') + " - " + moment(val[1]).add(i, 'y').lang(this.$store.state.locale).format('MMM YYYY') + ")"
                    });
                    
                }
                this.compareDateRange = -1;
            }
            
        },
        normalizationType(val){
            this.lastFilter.normalizationType = val;
            this.rePrepareData();
        }
    },

    created() {
        this.retriveData();
    }
};
</script>

<style lang="scss" scoped>
table {
  th.sorted {
    &.desc::after {
      display: inline-block;
      content: '▼';
    }
    &.asc::after {
      display: inline-block;
      content: '▲';
    }
  }
}
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "domestic-waste": "Atık",
            "next-year": "Sonraki sene",
            "previous-year": "Önceki sene",
            "data-type": "Veri Tipi",
            "reporting-period": "Raporlama Dönemi",
            "comparing-period": "Karşılaştırma Dönemi",
            "normalization-parameter": "Normalizasyon",
            "site-type": "Lokasyon Tipi",
            "filter": "Filtrele",
            "filtering": "Filtreleniyor",
            "numberOfStaff": "Kişi sayısı",
            "diffrence": "Değişim",
            "start-date": "Başlangıç tarihi",
            "end-date": "Bitiş tarihi",
            "person": "Kişi",
            "this-month": "Bu ay",
            "this-year": "Bu yıl",
            "last-6-months": "Son 6 ay",
            "Site": "Lokasyon"
        },
        "en": {
            "domestic-waste": "Waste",
            "next-year": "Year later",
            "previous-year": "Year prior",
            "data-type": "Data Type",
            "reporting-period": "Reporting Period",
            "comparing-period": "Comparison Period",
            "normalization-parameter": "Normalization",
            "site-type": "Location Type",
            "filter": "Filter",
            "filtering": "Filtering",
            "numberOfStaff": "Number of Occupants",
            "diffrence": "Diffrence",
            "start-date": "Start date",
            "end-date": "End date",
            "person": "Occupants",
            "this-month": "This month",
            "this-year": "This year",
            "last-6-months": "Last 6 months",
            "Site": "Site"
        }
    }
</i18n>




// WEBPACK FOOTER //
// src/views/Analysis/Tabs/Compare.vue